import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const ExposuresListItemStyle: StyleExtend<Theme> = {
  display: 'flex',
  gap: '1rem',
  alignItems: 'start',

  ':last-of-type': {
    paddingBottom: '1.5rem',
  },
};

export const ExposuresListItemContentWrapperStyle: StyleExtend<Theme> = {
  flex: '1',
  display: 'flex',
  flexDirection: 'column',
  gap: '.25rem',
};

export const ExposuresListItemEditBtnStyle: StyleExtend<Theme> = {
  display: 'flex',
  gap: '.25rem',
  padding: 0,
  justifyContent: 'start',
  width: 'fit-content',
  textAlign: 'left',
  path: {
    stroke: 'currentColor',
  },
  '&>span:first-of-type': (theme) => theme.mixins.textOverflowStyle(),
};
